/**
 * Class for DataSource
 */
export default class DataSource {
  constructor({
    datasource_id,
    datasource_name,
    account_id,
    created_at,
    created_by,
    modified_at,
    modified_by,
    schema,
    is_ping_data,
  }) {
    this.id = datasource_id;
    this.name = datasource_name;
    this.datasource_id = datasource_id;
    this.datasource_name = datasource_name;
    this.account_id = account_id;
    this.created_at = created_at;
    this.created_by = created_by;
    this.modified_at = modified_at;
    this.modified_by = modified_by;
    this.is_ping_data = is_ping_data;
    this.columns = [];

    Object.keys(schema.columns).forEach(column_name => {
      let {
        data_type,
        info_type,
        primary_key,
        nullable,
        is_dimension,
        is_measure,
        max_length,
        select_from,
        aggs,
      } = schema.columns[column_name];

      // if there is a select_from column, make it drop down friendly
      if (select_from) {
        select_from = select_from.map(column_name => ({
          id: column_name,
          name: column_name,
        }));
      }

      // check if there are aggregations
      if (aggs) {
        aggs = aggs.map(item => ({
          id: item,
          name: item,
        }));
      }

      this.columns.push({
        id: `${datasource_id}__${column_name}`,
        name: column_name,
        description: datasource_name,
        data_type,
        info_type,
        primary_key,
        nullable,
        is_dimension,
        is_measure,
        max_length,
        select_from,
        aggs,
      });
    });
  }
}
